"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Switch = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var css = _interopRequireWildcard(require("./Switch.style"));

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Switches toggle the state of a single setting on or off.
 *
 * The Switch component renders a styled span element with a checkbox input
 * as one of its children, for styling purposes.
 *
 * All HTML attributes supported by `<input>`s are supported, and forwarded to
 * the corresponding `input` element. The className prop, however, is placed on
 * the root node, to aid in applying custom styles to any of the component's
 * children, via child selectors.
 *
 * `ref`s are forwarded to the `input` element.
 *
 * For accessibility purposes, an ID attribute must be present so that the
 * input and label can be properly associated. If no ID is provided, a default
 * value of name + '-input' will be used, but this does not guarantee
 * uniqueness. If multiple forms, or different inputs with the same name values
 * are present on a single page, you must add your own IDs.
 */
const Switch = /*#__PURE__*/React.forwardRef(({
  className,
  ...otherProps
}, ref) => {
  const fallbackId = "".concat(otherProps.name ? otherProps.name : 'switch', "-input");
  return (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    as: "span",
    className: className,
    css: css.root,
    inline: true,
    justifyContent: "center"
  }, (0, _pragma.createFelaElement)("input", _extends({
    css: css.input,
    id: fallbackId,
    ref: ref,
    type: "checkbox"
  }, otherProps)), (0, _pragma.createFelaElement)("span", {
    css: css.toggle
  }), (0, _pragma.createFelaElement)("span", {
    css: css.background
  }));
});
exports.Switch = Switch;
Switch.displayName = 'Switch';
var _default = Switch;
exports.default = _default;
//# sourceMappingURL=Switch.js.map